import { useMutation } from '@tanstack/react-query'

import axios, { AxiosResponse } from 'axios'
import { Product } from '../types/product'

const { REACT_APP_MORTGAGE_URL } = process.env

const fetchProducts = async (runSourceArgument: any, apiKey: string) => {
  try {
    const response: AxiosResponse<Product[]> = await axios.post(
      `${REACT_APP_MORTGAGE_URL}/api/product/get${apiKey ? `?apiKey=${apiKey}` : ''}`,
      runSourceArgument
    )

    return response.data
  } catch (err) {
    return []
  }
}

const useDoGetProducts = () => {
  return useMutation({
    mutationKey: ['doGetProducts'],
    mutationFn: ({ runSourceArgument, apiKey }: { runSourceArgument: any, apiKey: string }) =>
      fetchProducts(runSourceArgument, apiKey),
  })
}

export default useDoGetProducts
